export const getLocalStorageItem = (key, defaultValue) => {
  try {
    return localStorage.getItem(key) ? JSON.parse(localStorage.getItem(key)) : defaultValue;
  } catch (e) {
    console.error(`Error parsing ${key} from localStorage:`, e);
    localStorage.removeItem(key);
    return defaultValue;
  }
};

// Matches a candidate against a `?showCandidate=` deep-link id. New links carry
// the candidateProfileId; older links (pre profile-key transition) carry the
// candidate's user id, so we accept either to keep shared/bookmarked links
// working.
export const candidateMatchesDeepLinkId = (candidate, deepLinkId) => {
  if (!candidate || !deepLinkId) return false;
  return (
    candidate.candidateProfileId === deepLinkId || candidate.userId === deepLinkId
  );
};

export const avatarUrl = (name, color = "random", rounded = "true") => {
  if (!name) return `https://ui-avatars.com/api/?name=Default&background=${color}&rounded=${rounded}`;
  const formattedName = name.replace(/ /g, "+");
  return `https://ui-avatars.com/api/?name=${formattedName}&background=${color}&rounded=${rounded}`;
}